"use client";
import type { RequestCookie } from "next/dist/compiled/@edge-runtime/cookies";
import qs from "qs";
import React, {Fragment, useEffect, useRef, useState} from "react";
import { useAuth } from "../../../_providers/Auth";
import { Rating } from "react-simple-star-rating";
import { Access } from "payload/config";
import { PRODUCT_ID } from "../../../_graphql/products";

import classes from "./index.module.scss";
import { Review } from '../../../../payload/payload-types';

export default function ReviewsBlock({ productId }) {
  const [messages, setMessages] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [rating, setRating] = useState(0);
  const [ratingValue, setRatingValue] = useState(0);
  const hasFetched = useRef(false);

  const processRatings = (allReviewRatings) => {
    let totalRatings = 0;
    let totalReviews = allReviewRatings.length;
    allReviewRatings?.map((ratings, index) => {
      totalRatings += ratings.rating;
      // console.log(ratings.rating, "Ratings value");
    });
    let totalRatingValues = totalRatings / totalReviews;
    setRatingValue(totalRatingValues);
  };

  useEffect(() => {
    async function getReviews() {
      const queryT = `query {
            Reviews(where: { AND: [{ product: { equals: "${productId}" }}] }) {
            docs {
                id
                rating
            }
        }
    }`;

      if (!loaded) {
        const docs: Review[] = await fetch(`${process.env.NEXT_PUBLIC_SERVER_URL}/api/graphql`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: queryT,
          }),
        })
          ?.then((res) => res.json())
          ?.then((res) => {
            //console.log(res?.data["Reviews"]?.docs, "Reviews yes");
            let allReviews = res?.data["Reviews"]?.docs;
            processRatings(allReviews);
            setRating(allReviews.length);
            setLoaded(true);

            if (res.errors) throw new Error(res?.errors?.[0]?.message ?? "Error fetching docs");
            return res?.data["Reviews"]?.docs;
          });
      }
    }
    if (!hasFetched.current) {
      getReviews();
      hasFetched.current = true; // Ensures function runs only once
    }
  }, [messages, loaded]);

  return (
    <div className={classes.blockSection}>
      <div className={classes.ratingCount}>
        <Rating
          size={20}
          readonly
          initialValue={ratingValue}
        />
        <span>({rating})</span>
      </div>
    </div>
  );
}
